App.directive('familyMemberInvitations', ['Config', function (Config) {
    FamilyMemberInvitationsController.$inject = ['$scope', 'userInvitationService', 'popUpService'];
    return {
        restrict: 'E',
        scope: {
            user: '=',
            lifePartner: '='
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/family-member-invitations.html',
        controller: FamilyMemberInvitationsController,
    }

    function FamilyMemberInvitationsController($scope, userInvitationService, popUpService) {

        var self = this;

        self.hasLifePartner = false;
        self.hasSpouse = false;

        self.hasLifePartnerInvitation = false;
        self.hasSpouseInvitation = false;

        $scope.userInvitations = [];
        $scope.newUserInvitation = false;
        $scope.newUserInvitations = [];
        $scope.relationType = getAvailableRelationTypes();

        loadUserInvitations();

        $scope.addNewUserInvitation = function () {

            if ($scope.newUserInvitations.length < 10) {
                var relationType = null;
                var relationTypes = getAvailableRelationTypes();
                if (relationTypes.length === 1) {
                    relationType = relationTypes[0].value;
                }
                $scope.newUserInvitations.push({
                    email: '',
                    relationType: relationType,
                    availableRelationTypes: relationTypes
                });
            }
            updateAvailableRelationTypes();
        };
        $scope.addNewUserInvitation();

        $scope.deleteUserInvitation = function (index) {
            $scope.newUserInvitations.splice(index, 1);
            updateAvailableRelationTypes();
        }

        $scope.sendNewUserInvitations = function () {
            var vm = this;
            if (!vm.form.$valid) {
                popUpService.showPopUp({content: 'Aby wysłać zaproszenia wypełnij wszystkie obowiązkowe pola (oznaczone gwiazdką).'})
                return 0;
            }

            if (_.find($scope.newUserInvitations, {email: $scope.user.email})) {
                popUpService.showPopUp({content: 'Nie można wysłać zaproszenia na adres <b>' + $scope.user.email + '</b> należący do użytkownika. Wprowadź inny e-mail.'})
                return 0;
            }

            var allActiveInvitations = _.concat(_.filter($scope.userInvitations, function (invitation) { return invitation.status !== 'DECLINED'}), $scope.newUserInvitations);
            var emailsCount = _.countBy(allActiveInvitations, 'email');
            var emails = _.keys(emailsCount);
            for (var i = 0; i < emails.length;i++) {
                if (emailsCount[emails[i]] > 1) {
                    popUpService.showPopUp({content: 'Nie można wysłać kilku zaproszeń na ten sam adres e-mail ' + emails[i] + '.'})
                    return 0;
                }
            }

            var data = {
                invitations: $scope.newUserInvitations
            }
            var f = $scope.form;
            userInvitationService.sendInvitations(data).then(function () {
                $scope.newUserInvitations = [];
                loadUserInvitations();
            })
        };

        $scope.$watch('newUserInvitations', function (newVal, oldVal) {
            self.hasSpouseInvitation = false;
            self.hasLifePartnerInvitation = false;
            angular.forEach($scope.userInvitations, function (invitation) {
                if (invitation.relationType === 'SPOUSE') {
                    self.hasSpouseInvitation = true;
                }
                if (invitation.relationType === 'LIFE_PARTNER') {
                    self.hasLifePartnerInvitation = true;
                }
            })
            angular.forEach(newVal, function (invitation) {
                if (invitation.relationType === 'SPOUSE') {
                    self.hasSpouseInvitation = true;
                }
                if (invitation.relationType === 'LIFE_PARTNER') {
                    self.hasLifePartnerInvitation = true;
                }
            });
            updateAvailableRelationTypes();
        }, true);

        $scope.$watch('lifePartner', function (newVal, oldVal) {
            if ($scope.lifePartner) {
                self.hasLifePartner = true;
                self.hasSpouse = false;
            }
            updateAvailableRelationTypes();
        }, true);

        function loadUserInvitations() {
            userInvitationService.getInvitations().then(function (data) {
                if (data.status === 200) {
                    $scope.userInvitations = data.data;
                    angular.forEach($scope.userInvitations, function (invitation) {
                        if (invitation.relationType === 'SPOUSE') {
                            self.hasSpouseInvitation = true;
                        }
                        if (invitation.relationType === 'LIFE_PARTNER') {
                            self.hasLifePartnerInvitation = true;
                        }
                    });
                    updateAvailableRelationTypes();
                }
            });
        }

        function updateAvailableRelationTypes() {
            angular.forEach($scope.newUserInvitations, function (invitation) {
                if (invitation.relationType === 'ADULT_CHILD' || invitation.relationType === null) {
                    let availableRelationTypes = getAvailableRelationTypes();
                    if (availableRelationTypes.length === 1) {
                        invitation.relationType = availableRelationTypes[0].value;
                    }
                    invitation.availableRelationTypes = availableRelationTypes;
                }
            });
        }


        function getAvailableRelationTypes() {
            var relationTypes = []
            if (!self.hasLifePartner) {
                if (!self.hasSpouseInvitation) {
                    relationTypes.push({label: 'Małżonek', value: 'SPOUSE'});
                }
            } else {
                if (!self.hasLifePartnerInvitation) {
                    relationTypes.push({label: 'Partner życiowy', value: 'LIFE_PARTNER'});
                }
            }

            relationTypes.push({label: 'Pełnoletnie dziecko', value: 'ADULT_CHILD'});
            return relationTypes;
        }

    }
}]);